import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    ChangeDetectorRef,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PermissionDialogComponent } from '../permission-dialog/permission-dialog.component';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';
import { IACL } from 'src/app/acl-data/acl.interface';

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PermissionsComponent),
            multi: true,
        },
    ],
})
export class PermissionsComponent implements ControlValueAccessor, OnChanges {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @Input() editMode = false;
    value: IACL[];
    onChanges = [];
    onTouched = [];
    touched = false;
    disabled = false;
    users = [];

    dataSource;
    displayedColumns: string[] = this.editMode
        ? ['Action', 'Username', 'Level', 'ExpiryDate']
        : ['Username', 'Level', 'ExpiryDate'];

    ngOnChanges(changes: SimpleChanges): void {
        this.displayedColumns = this.editMode
            ? ['Action', 'Username', 'Level', 'ExpiryDate']
            : ['Username', 'Level', 'ExpiryDate'];
    }

    displayChange() {
        if (this.value) {
            this.dataSource = new MatTableDataSource<any>(this.value);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    constructor(
        private cbr: ChangeDetectorRef,
        public dialog: MatDialog,
        private i1FilenetServices: I1FilenetServices
    ) {
        this.i1FilenetServices.getUsers().subscribe(v => (this.users = v));
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    writeValue(obj: IACL[]): void {
        // console.log('Set Folder Perm', obj);
        this.value = obj;
        this.displayChange();
    }
    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }

    formChanged = (input: any) => {
        for (const change of this.onChanges) {
            change(this.value);
        }

        this.markAsTouched();
        this.displayChange();
    };

    formTouched = (input: any) => {
        this.touched = true;
        for (const touch of this.onTouched) {
            touch(input);
        }
    };

    markAsTouched() {
        this.touched = true;
        this.formTouched({});
    }

    addPermission = () => {
        console.log('Add Permission');
        if (this.editMode) {
            const availableUsers = this.users.filter(
                v => !this.value.find(val => val.direct && val.name === v)
            );
            const dialogRef = this.dialog.open(PermissionDialogComponent, {
                data: { users: availableUsers },
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.value = [result, ...this.value];

                    this.formChanged(this.value);
                }
            });
        }
    };

    delete = input => {
        console.log('Delete', input);
        if (input.direct) {
            this.value = this.value.filter(v => v !== input);

            this.formChanged(this.value);
        }
    };

    edit = input => {
        if (input.direct && this.editMode) {
            console.log('edit', input);
            input.level = input.level === 'Initiator' ? 'Read' : 'Initiator';
            this.formChanged(this.value);
        }
    };

    applyFilter(filterValue: string) {
        console.log('Filter');
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.paginator) {
            this.paginator.firstPage();
        }
    }
}
